import { useCallback, useEffect, useState } from "react";
import { UseSvgImageLoadedArgs } from "./types";

export const useSvgImageLoad = ({ src }: UseSvgImageLoadedArgs) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    setIsImageLoaded(false);
  }, [src]);

  const onImageLoad = useCallback(() => {
    setIsImageLoaded(true);
  }, []);

  const onImageError = useCallback(() => {
    setIsImageLoaded(false);
  }, []);

  return {
    isImageLoaded,
    onImageLoad,
    onImageError,
  };
};
